import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiService } from './api.service';
import { URLS } from '../constants/URLS';
import { LiveStream, PlaybackUrlResponse, ViewerCountResponse } from '../_model/live-stream.model';

@Injectable({
  providedIn: 'root'
})
export class LiveStreamService {

  constructor(private api: ApiService) {}

  /**
   * Fetch live/scheduled/provisioned streams for discovery.
   * Backend returns either a cached List (from Redis) or a paginated Page.
   */
  getDiscoveryStreams(): Observable<LiveStream[]> {
    const url = `${URLS.liveStreams}?status=LIVE,SCHEDULED,PROVISIONED`;
    return this.api.get(url).pipe(
      map(response => {
        if (Array.isArray(response)) return response;
        if (response?.data && Array.isArray(response.data)) return response.data;
        if (response?.content && Array.isArray(response.content)) return response.content;
        return [];
      }),
      catchError(() => of([]))
    );
  }

  getStreamDetail(streamId: number): Observable<LiveStream> {
    return this.api.get(`${URLS.liveStreamDetail}${streamId}`);
  }

  getPlaybackUrl(streamId: number): Observable<PlaybackUrlResponse> {
    return this.api.get(`${URLS.liveStreamDetail}${streamId}/playback-url`);
  }

  getViewerCount(streamId: number): Observable<ViewerCountResponse> {
    return this.api.get(`${URLS.liveStreamDetail}${streamId}/viewers`);
  }

  joinStream(streamId: number): Observable<any> {
    return this.api.post(`${URLS.liveStreamDetail}${streamId}/viewer/join`, {}).pipe(
      catchError(() => of(null))
    );
  }

  sendHeartbeat(streamId: number): Observable<any> {
    return this.api.post(`${URLS.liveStreamDetail}${streamId}/viewer/heartbeat`, {}).pipe(
      catchError(() => of(null))
    );
  }

  leaveStream(streamId: number): Observable<any> {
    return this.api.post(`${URLS.liveStreamDetail}${streamId}/viewer/leave`, {}).pipe(
      catchError(() => of(null))
    );
  }

  addReminder(streamId: number): Observable<any> {
    return this.api.post(`${URLS.liveStreamDetail}${streamId}/reminder`, {});
  }

  removeReminder(streamId: number): Observable<any> {
    return this.api.delete(`${URLS.liveStreamDetail}${streamId}/reminder`);
  }
}
